export function useProxy() {
  const formatProxy = (domain: string) => {
    const arr = domain.split('.');

    if (arr.length === 2) {
      return arr.join('.');
    } else {
      return arr.slice(1).join('.');
    }
  };

  return {
    formatProxy,
  };
}
